import React,{useContext} from 'react'
import DatePicker from "react-datepicker";

import {HandleDecimal} from "../../common/Utils";

import { AppContext } from "../../AppContext";
import UserSelectBox from "../common/controls/UserSelectBox";

const PoliticalFormDonateJwcole = (props)=> {
    const [appContext, setAppContext] = useContext(AppContext);
    return (

        <div className="form-items mt-4">
                    
            <div className="form-columns">

                <div className="form-column">
                
                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.politicalOrganizationName ? "" : "warning" }`} htmlFor="politicalOrganizationName">Name of the Person/Entity the money is being raised for : </label>
                        <input className="form-item-value" type="text" id="politicalOrganizationName" name="politicalOrganizationName" maxLength="500" value={props.data.politicalOrganizationName} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item mt-4">
                        <label className={`form-item-label required ${props.validation.politicalOrganizationType ? "" : "warning"}`}>
                        Type of Organization: <em>(check one)</em>
                        </label>
                        <div className="form-item-value">
                            <div className="label-group-block">
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationType" value="Political Party" className="form-check-input" checked={props.data.politicalOrganizationType === "Political Party"} onChange={props.handleChange}/>
                                    Political Party
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationType" value="PAC" className="form-check-input" checked={props.data.politicalOrganizationType === "PAC"} onChange={props.handleChange}/>
                                    PAC
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationType" value="Other" className="form-check-input" checked={props.data.politicalOrganizationType === "Other"} onChange={props.handleChange}/>
                                    Other
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.officeSought ? "" : "warning" }`} htmlFor="officeSought">Office Sought : </label>
                        <input className="form-item-value" type="text" id="officeSought" name="officeSought" maxLength="500" value={props.data.officeSought} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item mt-4">
                        <label className={`form-item-label required ${props.validation.officeSoughtJurisdiction ? "" : "warning" }`}>
                        Jurisdiction of Office sought : <em>(check one)</em>
                        </label>
                        <div className="form-item-value">
                            <div className="label-group-block">
                                <label className="flex-1">
                                    <input type="radio" name="officeSoughtJurisdiction" value="City" className="form-check-input" checked={props.data.officeSoughtJurisdiction === "City"} onChange={props.handleChange}/>
                                    City
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="officeSoughtJurisdiction" value="County" className="form-check-input" checked={props.data.officeSoughtJurisdiction === "County"} onChange={props.handleChange}/>
                                    County
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="officeSoughtJurisdiction" value="State" className="form-check-input" checked={props.data.officeSoughtJurisdiction === "State"} onChange={props.handleChange}/>
                                    State
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="officeSoughtJurisdiction" value="Federal" className="form-check-input" checked={props.data.officeSoughtJurisdiction === "Federal"} onChange={props.handleChange}/>
                                    Federal
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label`} htmlFor="officeHeld">Office currently held (if any) : </label>
                        <input className="form-item-value" type="text" id="officeHeld" name="officeHeld" maxLength="500" value={props.data.officeHeld} onChange={props.handleChange}/>
                    </div>
                    
                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.electionDate ? "" : "warning"}`} htmlFor="electionDate">Date of Election:</label>
                        <div className="form-item-value">
                            <DatePicker selected={props.data.electionDate} onChange={p=>props.handleDateChange(p,"electionDate")}/>
                        </div>
                    </div>

                </div>

                <div className="form-column">
                  
                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.description ? "" : "warning" }`} htmlFor="description">Description of Activity :</label>
                        <input className="form-item-value" type="text" id="description" name="description" maxLength="500" value={props.data.description} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.contributePersonalFund ? "" : "warning"}`}>
                        Will you make expenditures from personal funds in connection with the activity? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="contributePersonalFund" value="Yes" className="form-check-input" checked={props.data.contributePersonalFund === "Yes"} onChange={props.handleChange}/>
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="contributePersonalFund" value="No" className="form-check-input" checked={props.data.contributePersonalFund === "No"} onChange={props.handleChange}/>
                                No
                            </label>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.engagementInWorkingHours ? "" : "warning"}`}>
                        Will you engage in the activity during working hours? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="engagementInWorkingHours" value="Yes" className="form-check-input" checked={props.data.engagementInWorkingHours === "Yes"} onChange={props.handleChange}/>
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="engagementInWorkingHours" value="No" className="form-check-input" checked={props.data.engagementInWorkingHours === "No"} onChange={props.handleChange}/>
                                No
                            </label>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.engagementHours ? "" : "warning" }`} htmlFor="engagementHours">How many hours will you engage in this activity during working hours? :</label>
                        <input className="form-item-value" type="text" id="engagementHours" name="engagementHours" maxLength="500" value={props.data.engagementHours} onChange={e=>HandleDecimal(e,props.handleChange)}/>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.usingOfficeResource ? "" : "warning"}`}>
                        Will you be using any company resources(office space, personnel(i.e., administrative assistants), equipment, phones, copiers or computers? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="usingOfficeResource" value="Yes" className="form-check-input" checked={props.data.usingOfficeResource === "Yes"} onChange={props.handleChange}/>
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="usingOfficeResource" value="No" className="form-check-input" checked={props.data.usingOfficeResource === "No"} onChange={props.handleChange}/>
                                No
                            </label>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.contribDate ? "" : "warning"}`} htmlFor="contribDate">Contribution or Planned For Date:</label>
                        <div className="form-item-value">
                            <DatePicker selected={props.data.contribDate} onChange={p=>props.handleDateChange(p,"contribDate")}/>
                        </div>
                    </div>


                  <div className="form-item">
                      <label className="form-item-label" htmlFor="attachment">Attachment Document (if applicable) :</label>
                      <div className="form-item-value placeholder">
                          <input type="file" name="attachment" id="attachment" onChange={props.handleChange}/>
                      </div>
                  </div>
                  <div className="form-item">
                        {appContext.user.submitOnBehalf && props.editorMode === 'NEW' &&
                            <UserSelectBox label='Submit On Behalf of (Optional) : ' styleClass='mt-3rem' onSelected={props.handleChange} name='submittedFor' value={() => { return props.data.submittedFor ? { value: props.data.submittedFor, label: props.data.submittedForLabel } : null }} />
                        }
                    </div>
                </div>

            </div>
        

        </div>

    );

};

export default PoliticalFormDonateJwcole;
